import React from 'react';
import { RegionType } from './RegionType.enum';
import { BasePanel } from './BasePanel.component';

export const CenterPanel = ({ children }) => (
	<BasePanel className="common-layout center-panel" region={RegionType.Center}>
		{children}
	</BasePanel>
);
